import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';

// Views
import PrescriptionFillsListView from './prescriptions-fills-mail-ordered-view';

// Helpers
import * as helpers from './helpers';

// Stores
import stores from 'bootstrap/store';
import { prescriptionFillsMailOrderRouteStore } from './domain/store';

// Hooks
import useActivePharmacistPrompt from 'singletons/activePharmacistPrompt/useActivePharmacistPrompt';

const prescriptionFillsStore = stores.global.prescriptionFills;


const PrescriptionsFillsMailOrderedContainer = ({ rootRoute }) => {
  const navigate = useNavigate();
  const { prescriptionFillId } = useParams();

  useEffect(() => {
    prescriptionFillsMailOrderRouteStore.setValue('activePrescriptionFillId', null);
    helpers.listPrescriptionFills();

    return () => {
      prescriptionFillsStore.setInitialState();
      prescriptionFillsMailOrderRouteStore.setInitialState();
    };
  }, []);

  useEffect(() => {
    if (!prescriptionFillsMailOrderRouteStore.http.listingMailOrderedPrescriptionFills) {
      helpers.determineActivePrescriptionFill(prescriptionFillId, navigate);
    }
  }, [prescriptionFillId, prescriptionFillsMailOrderRouteStore.http.listingMailOrderedPrescriptionFills]);

  const { initiatePrompt } = useActivePharmacistPrompt();

  function processMailOrder(action) {
    initiatePrompt({
      timeout: 10_000,
      onIdentify: () => {},
      onPharmacist: ({ pharmacist }) => {
        helpers.processMailOrder({ actingPharmacistId: pharmacist.id });
      },
    });
  }

  return <PrescriptionFillsListView
    prescriptionFillsStore={prescriptionFillsStore}
    prescriptionFillsMailOrderRouteStore={prescriptionFillsMailOrderRouteStore}
    listPrescriptionFills={helpers.listPrescriptionFills}
    onPrescriptionFillsSearch={helpers.onPrescriptionFillsSearch}
    processMailOrder={processMailOrder}
    rootRoute={rootRoute}
  />;
};


export default observer(PrescriptionsFillsMailOrderedContainer);
